import { useSelector } from "react-redux";
import { ReduxStore } from "../../../interfaces/store";
import { useEffect } from "react";
import { userActions } from '../../../redux/user';
import { useAppDispatch } from "@services/hooks/helperHooks";

export function useShortNews() {

    const dispatch = useAppDispatch();
    const state = useSelector(({user}: ReduxStore) => user.shortNews);

    useEffect(() => {
        dispatch(userActions.loadNews());
    }, [dispatch])
    return state;
}